import { resources } from "@constants/hardcoded-strings";
import { ButtonTypes } from "@enums/button-types";
import { ModalSizeTypes } from "@enums/modal-size-types";
import { GenericAccountStateTypes } from "@enums/generic-account-state-types";
import { FormEvent, useMemo, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { ButtonWithSpinner } from "../../common/button-with-spinner/button-with-spinner";
import { DefaultModal } from "../../common/modals/default-modal/default-modal";
import defaultStyles from "../../common/modals/default-modal/default-modal.less";
import { EntityUpdateModalOptions } from "@idw-types/entity-update-modal-option";

type EntityStatusUpdateModalProps = {
    onModalClose: () => void;
    entityModalOptions: EntityUpdateModalOptions;
    entityAccountStateType: GenericAccountStateTypes;
    onUpdateStatus: () => Promise<{ data: any }>;
};

export const EntityStatusUpdateModal = (props: EntityStatusUpdateModalProps) => {
    const { entityModalOptions, entityAccountStateType, onModalClose, onUpdateStatus } = props;
    const baseResources: { [key: string]: any } = resources;
    const [requestInProgress, setRequestInProgress] = useState(false);


    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        setRequestInProgress(true);

        const { data } = await onUpdateStatus();
        if (data) {
            onModalClose();
        } else {
            setRequestInProgress(false);
        }
    };

    const entityOptions = useMemo(() => {
        return {
            automationId: `${entityAccountStateType}-${entityModalOptions.key}-modal`,
            ariaLabelledBy: `${entityAccountStateType}-${entityModalOptions.key}-title`,
            headerId: `${entityAccountStateType}-${entityModalOptions.key}-title`,
            modalResource: baseResources.modals[`${entityAccountStateType}${entityModalOptions.textResourceKey}`],
            requestResource: baseResources.requests[`${entityAccountStateType}${entityModalOptions.textResourceKey}`]
        }
    }, [entityModalOptions, entityAccountStateType]);

    return (
        <DefaultModal
            automationId={entityOptions.automationId}
            ariaLabelledBy={entityOptions.ariaLabelledBy}
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
            size={ModalSizeTypes.MEDIUM}
        >
            <Form onSubmit={handleSubmit}>
                <Modal.Header id={entityOptions.headerId} closeButton>
                    <Modal.Title>{entityOptions.modalResource.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className={defaultStyles.description}>
                        {entityOptions.modalResource.description}
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onModalClose}>{resources.common.buttons.cancel.label}</Button>
                    <ButtonWithSpinner
                        disabled={requestInProgress}
                        hideSpinner={false}
                        variant="primary"
                        type={ButtonTypes.SUBMIT}
                        label={entityOptions.modalResource.buttons.submit.label}
                    />
                </Modal.Footer>
            </Form>
        </DefaultModal>
    );
};